
  
 
<!-- <app-sidebar></app-sidebar> -->

  <!-- Top navbar -->
  <app-navbar></app-navbar>
  <!-- Pages -->
  <div class="container-fluid2">
    <router-outlet></router-outlet>

    <app-footer></app-footer>
  </div>
<!-- </div> -->
